import { render } from "./SignupView.vue?vue&type=template&id=7bc2bc64&scoped=true"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"

import "./SignupView.vue?vue&type=style&index=0&id=7bc2bc64&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc2bc64"]])

export default __exports__